/**
 * JeriCommerce Pass API · staging
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface RewardWithCouponCodeCountsDto { 
    id: string;
    status: RewardWithCouponCodeCountsDto.StatusEnum;
    order: number;
    title: string;
    totalCodes: number;
    claimedCodes: number;
    deletedAt: string | null;
}
export namespace RewardWithCouponCodeCountsDto {
    export const StatusEnum = {
        Available: 'available',
        NotAvailable: 'not_available',
        Deleted: 'deleted'
    } as const;
    export type StatusEnum = typeof StatusEnum[keyof typeof StatusEnum];
}


